
	import Vue from "vue"
	import Component from "vue-class-component"
	import DataView from "@components/data/view/DataView.vue"
	import { Column } from "@components/data/view/types"
	import Grid from "custom/table/Grid.vue"
	import { CompanyOverviewModel, CompanyPermissions } from "api/models/company"
	import { filterFunctions } from "custom/table/utils/filter-functions"
	import FilterField from "custom/table/FilterField.vue"
	import Loader from "custom/Loader.vue"
	import { Prop } from "vue-property-decorator"
	import userClient from "api/clients/user-client"
	import { impersonateUrl } from "api/settings"
	import { impersonate } from "../utils/impersonate"

	@Component({
		components: {
			DataView,
			Grid,
			FilterField,
			Loader
		}
	})
	export default class Customers extends Vue {
		@Prop({ type: Array, required: true, default: [] }) customers!: ReadonlyArray<CompanyOverviewModel>
		@Prop({ type: Array, required: true }) permissions!: ReadonlyArray<CompanyPermissions>
		@Prop({ type: Boolean, required: true }) loading!: boolean

		readonly baseTranslationKey = "portfolio.customers"
		readonly filters = filterFunctions
		readonly columns: ReadonlyArray<Column<CompanyOverviewModel>> = [
			{ title: `${ this.baseTranslationKey }.column.customerNumber`, field: "externalIdentifier" },
			{ title: `${ this.baseTranslationKey }.column.name`, field: "name" },
			{ title: `${ this.baseTranslationKey }.column.productAmount`, field: "agreementCount" },
			{ title: `${ this.baseTranslationKey }.column.actions`, field: "actions" }
		]

		showCustomerDetails(customer: CompanyOverviewModel): void {
			location.href = `customer.html?id=${ customer.externalIdentifier }`
		}

		async showImpersonateDetails(customer: CompanyOverviewModel): Promise<void> {
			const companyId = customer.externalIdentifier
			const response = await userClient.getImpersonateTokenByCompany(companyId)

			impersonate(response)
			window.open(impersonateUrl, "_blank")
		}
	}
